import React from 'react';
import ReactDOM from 'react-dom';
import App from './modules/App';
import './assets/custom/styles.css';

ReactDOM.render(<App />, document.getElementById('root'));
